import Button from "@/components/Button";
import Modal from "@/components/Modal";

interface OnboardingExitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirmExit: () => void;
}

/**
 * Modal component that appears when users attempt to exit the onboarding flow.
 * Warns users about missing out on the free trial and provides options to quit or continue.
 */
const OnboardingExitModal = ({
  isOpen,
  onClose,
  onConfirmExit,
}: OnboardingExitModalProps) => {
  return (
    <div className="OnboardingExitModal">
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          onClose();
          return null;
        }}
      >
        <h1
          className="mb-4 text-xl font-medium sm:text-3xl"
          data-posthog="onboarding-exit-modal-heading"
        >
          Are you sure you want to quit?
        </h1>
        <div
          className="mb-3 font-body text-base font-medium"
          data-posthog="onboarding-exit-modal-subheading"
        >
          You&apos;ll miss out on:
        </div>
        <ul className="space-y-2 font-body text-sm font-medium sm:text-base">
          <li className="flex items-center gap-2">
            <span>
              5-day free trial to access 3000+ healthy & delicious recipes and
              meal planning tools. Cancel anytime
            </span>
          </li>
        </ul>
        <div className="mt-6 flex w-full gap-2">
          <Button
            onClick={() => {
              onConfirmExit();
              return null;
            }}
            label="Quit"
            isFull
            theme="dark"
            withBorder
            attributes={{
              "data-posthog": "onboarding-exit-modal-quit-button",
            }}
          />
          <Button
            label="Continue"
            onClick={() => {
              onClose();
              return null;
            }}
            isFull
            theme="light"
            attributes={{
              "data-posthog": "onboarding-exit-modal-continue-button",
            }}
          />
        </div>
      </Modal>
    </div>
  );
};

export default OnboardingExitModal;
